import { render, staticRenderFns } from "./Habit.vue?vue&type=template&id=ffdcce52&scoped=true&"
import script from "./Habit.vue?vue&type=script&lang=js&"
export * from "./Habit.vue?vue&type=script&lang=js&"
import style0 from "./Habit.vue?vue&type=style&index=0&id=ffdcce52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffdcce52",
  null
  
)

export default component.exports